<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动信息</span>
      </div>
      <div style="width: 500px;">
        <el-form ref="infoForm" :model="infoForm" :rules="infoRules" label-width="100px">
          <el-form-item label="活动名称" prop="activityName">
            <el-input v-model="infoForm.activityName" placeholder="请输入活动名称" />
          </el-form-item>
          <el-form-item label="活动时间" prop="activityTime">
            <el-date-picker v-model="infoForm.activityTime" type="daterange" range-separator="至" start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" value-format="yyyy-MM-dd" />
          </el-form-item>
          <el-form-item label="活动说明" prop="activityExplain">
            <el-input v-model="infoForm.activityExplain" type="textarea" :rows="4" placeholder="请输入活动说明" />
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动奖励</span>
      </div>
      <div style="width: 550px;">
        <el-form ref="rewardForm" :model="rewardForm" :rules="rewardRules" label-width="100px">
          <template v-for="(row,index) in rewardForm.coupons">
            <el-form-item :key="index" :label="'优惠券'+numberfilter(index+1)" prop="activityReward">
              <div class="d-flex">
                <el-select v-model="row.couponId" filterable style="width: 200px;" placeholder="请选择优惠券" @change="(val)=>couponChange(val,index)">
                  <el-option v-for="item in allCoupon" :key="item.couponId" :label="item.couponName" :value="item.couponId" />
                </el-select>
                <el-input v-model="row.count" type="number" class="ml-20" style="width: 100px;" placeholder="请输入数量" />
                <div class="ml-20">张</div>
                <i class="icon-jia ml-20 el-icon-circle-plus-outline" @click="addCoupon(index)" />
                <i v-show="index!==0" class="icon-jia ml-20 el-icon-remove-outline" @click="delCoupon(index)" />
              </div>
              <div class="d-flex currentStock">当前库存：{{ row.totalNum }}</div>
            </el-form-item>
          </template>
        </el-form>
      </div>
    </el-card>
    <div class="flexJCenter mt-25">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="onSubmit()">保存</el-button>
    </div>
  </div>
</template>

<script>
import { numberfilter } from '@/utils/tool'
export default {
  data() {
    return {
      type: 1, // 当前页面所属的活动(1:注册活动,2:充值领券活动,3:单次消费活动,4:累计消费活动,5:分享活动)
      infoForm: {
        activityName: '', // 活动名称
        activityTime: [], // 活动时间
        activityExplain: ''// 活动说明
      },
      infoRules: {
        activityName: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        activityTime: [
          { required: true, message: '请选择活动时间', trigger: 'blur' }
        ],
        activityExplain: [
          { required: true, message: '请输入活动说明', trigger: 'blur' }
        ]
      },
      // 所有的优惠券数据
      allCoupon: [],
      // 活动奖励表单数据
      rewardForm: {
        coupons: [
          {
            couponId: '', // 优惠券id
            count: '', // 优惠券数量
            totalNum: ''// 优惠券库存
          }
        ]
      },
      rewardRules: {
        activityReward: { required: true, trigger: 'change', validator: (rewardRules, value, cb) => {
          if (this.rulesRewardRule) {
            return cb(new Error(this.rulesRewardRule))
          }
          return cb()
        } }
      }
    }
  },
  computed: {
    // 活动奖励表单的动态校验
    rulesRewardRule() {
      const dataArray = this.rewardForm.coupons
      for (let i = 0; i < dataArray.length; i++) {
        const currentObj = dataArray[i]
        if (currentObj.couponId === '' && !currentObj.couponId.length) {
          return '请选择优惠券'
        }
        if (!currentObj.count && !currentObj.count.length) {
          return '请输入数量'
        }
        if (currentObj.totalNum && currentObj.count > currentObj.totalNum) {
          return '优惠券数量大于库存数量'
        }
      }
      return ''
    }
  },
  mounted() {
    this.$nextTick(() => {
    // 加载优惠券数据
      this.loadCoupon()
    })
  },
  methods: {
    numberfilter(num) {
      return numberfilter(num)
    },
    // 加载优惠券数据
    loadCoupon() {
      const data = {
        pageNo: 1,
        pageSize: 1000,
        status: 0,
		hasStock:true
      }
      this.$store.dispatch('form/handle', {
        url: '/admin/coupon/getCouponList',
        data: data,
        method: 'post',
        callback: resp => {
          console.log('请求到的优惠券数据：', resp)
          this.allCoupon = resp.list
        }
      })
    },
    // 优惠券选择赋值
    couponChange(val, index) {
      this.allCoupon.forEach(item => {
        if (item.couponId === val) {
          this.rewardForm.coupons[index].totalNum = item.stock
        }
      })
    },
    /**
     * 表单添加一行优惠券
     */
    addCoupon(index) {
      console.log(111111);
      const data = {
        couponId: '', // 优惠券id
        count: '', // 优惠券数量
        totalNum: ''// 优惠券库存
      }
      this.rewardForm.coupons.splice(index + 1, 0, data)
    },
    /**
     * 删除删除一行优惠券
     */
    delCoupon(index) {
      this.rewardForm.coupons.splice(index, 1)
    },
    onSubmit() {
      let infoFormBool = false
      this.$refs['infoForm'].validate(valid => {
        infoFormBool = valid
      })
      let rewardFormBool = false
      this.$refs['rewardForm'].validate(valid => {
        rewardFormBool = valid
      })
      // 如果两个表单都验证正确
      if (infoFormBool && rewardFormBool) {
        // 进入提交数据函数
        this.submitData()
      }
    },
    submitData() {
      const couponsData = [{ coupons: [] }]
      this.rewardForm.coupons.forEach((item, index) => {
        couponsData[0].coupons.push({
          couponId: item.couponId,
          count: item.count
        })
      })
      const data = {
        type: this.type,
        name: this.infoForm.activityName,
        start: this.infoForm.activityTime[0],
        end: this.infoForm.activityTime[1],
        description: this.infoForm.activityExplain,
        coupons: couponsData
      }
      this.$store.dispatch('form/handle', {
        url: '/activity/save',
        data: data,
        method: 'post',
        callback: resp => {
          this.$notify({
            title: '成功',
            message: '新增成功',
            type: 'success',
            duration: 1500
          })
          this.$router.go(-1)
        }
      })
    },
    cancel() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
  .d-flex{
    display: flex;
  }
  .jc-sb{
    justify-content: space-between;
  }
  .flexJCenter{
    display: flex;
    justify-content: center;
  }
  .currentStock{
    height: 20px;
    align-items: center;
  }
  .ml-20{
    margin-left: 20px;
  }
  .mt-25{
    margin-top: 25px;
  }
  .icon-jia{
    font-size: 22px;
    align-items: center;
    display: flex;
  }
  //去除input的type为number时的上下箭头

  /deep/input::-webkit-outer-spin-button,
  /deep/input::-webkit-inner-spin-button { -webkit-appearance: none; }
  /deep/input[type="number"]{ -moz-appearance: textfield; }
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/registrationAdd.vue